// extracted by mini-css-extract-plugin
export default {"link":"styles_link__agQyJ","wrapper":"styles_wrapper__D+TGo"};